<template>
  <div>
    <div v-if="showReserve" class="reserveWrapper">
      <h1>Reserving the property</h1>
      <h2>
        To ensure that this property is secured, the purchaser is entitled to
        place a reservation on the property for a 7 day exclusive period, free
        of competition, to seek advice and proceed with the sale.
      </h2>
      <button class="btn" @click="reserve">Reserve this property</button>
      <button v-if="showCall" class="btn" @click="openPop">
        Request a call
      </button>
    </div>
    <div class="line"></div>
    <!--pop-->
    <transition name="fade">
      <div v-if="pop" class="popWrp">
        <div :class="{ short: isConfirm }" class="out">
          <div class="inn" v-bind:class="'tenant-' + tenant">
            <h1 v-if="!isConfirm" v-bind:class="'tenant-' + tenant">
              Confirm sending request?
            </h1>
            <h2 v-if="!isConfirm">
              Are you sure you want to send the request for a callback?
            </h2>
            <h1 v-if="isConfirm">Request a call back sent!</h1>
            <h2 v-if="isConfirm">
              Someone from the UNIFI team will be in touch with you in the next
              24 hours!
            </h2>
            <div v-if="!isConfirm" class="btns">
              <button @click="closePop">No thanks</button>
              <a :href="link" class="link" target="_blank" @click="confirm"
                >Yes please</a
              >
            </div>
            <button v-if="isConfirm" class="close" @click="closePop">
              Okay
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      link: "",
      isConfirm: false,
      pop: false,
      contactEmail: "",
      contactNumber: "",
      tenant: window.location.hostname
        .replace("m.", "")
        .split(".")[0]
        .split("testunifiproperty")[0]
        .split("unifiproperty")[0]
        .split("platform")[0]
    };
  },
  props: {
    showReserve: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    showCall: {
      type: Boolean,
      default: () => {
        return true;
      }
    }
  },
  created() {
    var that = this;
    that.getList({ callback: that.contactCallback });
  },
  methods: {
    ...mapActions("contact", ["getList"]),
    reserve() {
      this.$emit("accept");
    },
    openPop() {
      var that = this;
      that.pop = true;
      that.isConfirm = false;
    },
    closePop() {
      this.pop = false;
    },
    confirm() {
      var that = this;
      setTimeout(() => {
        that.isConfirm = true;
      }, 1000);
    },
    setLink(val) {
      var that = this;
      val.address =
        val.address.indexOf("&") == -1
          ? val.address
          : val.address.split("&").join("and");
      let maxRental = "";
      let maxPrice = "";
      if (val.maxRental) maxRental = " - " + "$" + val.maxRental;
      if (val.maxPrice !== "0" && val.maxPrice !== 0)
        maxPrice = " - " + "$" + val.maxPrice;
      if (val.proertyType == "Apartments & Units") {
        that.link =
          "mailto:" +
          this.contactEmail +
          "?subject=<Submit Request Form>&body=" +
          "Referrer's name: " +
          sessionStorage.getItem("d") +
          "%0d%0a" +
          "Referrer's email address: " +
          sessionStorage.getItem("a") +
          "%0d%0a" +
          "Referrer's contact number: " +
          sessionStorage.getItem("b") +
          "%0d%0a" +
          "Referrer's mobile number: " +
          sessionStorage.getItem("c") +
          "%0d%0a" +
          "========================================" +
          "%0d%0a" +
          "Property Address : " +
          val.address +
          " " +
          val.suburb +
          " " +
          val.state +
          " " +
          val.postcode +
          "%0d%0a" +
          "Property Type : " +
          "Apartments and Units" +
          "%0d%0a" +
          "Price : " +
          "$" +
          val.price +
          maxPrice +
          "%0d%0a" +
          "Estimated rent per week : " +
          "$" +
          val.rental +
          maxRental +
          "%0d%0a" +
          "Rental yield : " +
          val.rentalYield +
          "%" +
          "%0d%0a" +
          "Vacancy rate : " +
          val.vacancyRate +
          "%" +
          "%0d%0a" +
          "Build Size : " +
          val.buildSize +
          "m2" +
          "%0d%0a" +
          "Beds : " +
          val.bedsNumber +
          "%0d%0a" +
          "Bathrooms : " +
          val.bathroomsNumber +
          "%0d%0a" +
          "Car Spaces : " +
          val.carSpacesNumber +
          "%0d%0a" +
          "Additional Comments : " +
          "%0d%0a" +
          "A Unifi representative will be in touch within the next 24-48 Hours." +
          "%0d%0a";
      } else if (val.proertyType == "Townhouses") {
        that.link =
          "mailto:" +
          this.contactEmail +
          "?subject=<Submit Request Form>&body=" +
          "Referrer's name: " +
          sessionStorage.getItem("d") +
          "%0d%0a" +
          "Referrer's email address: " +
          sessionStorage.getItem("a") +
          "%0d%0a" +
          "Referrer's contact number: " +
          sessionStorage.getItem("b") +
          "%0d%0a" +
          "Referrer's mobile number: " +
          sessionStorage.getItem("c") +
          "%0d%0a" +
          "========================================" +
          "%0d%0a" +
          "Property Address : " +
          val.address +
          " " +
          val.suburb +
          " " +
          val.state +
          " " +
          val.postcode +
          "%0d%0a" +
          "Property Type : " +
          "Townhouses" +
          "%0d%0a" +
          "Price : " +
          "$" +
          val.price +
          maxPrice +
          "%0d%0a" +
          "Estimated rent per week : " +
          "$" +
          val.rental +
          maxRental +
          "%0d%0a" +
          "Rental yield : " +
          val.rentalYield +
          "%" +
          "%0d%0a" +
          "Vacancy rate : " +
          val.vacancyRate +
          "%" +
          "%0d%0a" +
          "Build Size : " +
          val.buildSize +
          "m2" +
          "%0d%0a" +
          "Beds : " +
          val.bedsNumber +
          "%0d%0a" +
          "Bathrooms : " +
          val.bathroomsNumber +
          "%0d%0a" +
          "Car Spaces : " +
          val.carSpacesNumber +
          "%0d%0a" +
          "Additional Comments : " +
          "%0d%0a" +
          "A Unifi representative will be in touch within the next 24-48 Hours." +
          "%0d%0a";
      } else if (val.proertyType == "Houses") {
        that.link =
          "mailto:" +
          this.contactEmail +
          "?subject=<Submit Request Form>&body=" +
          "Referrer's name: " +
          sessionStorage.getItem("d") +
          "%0d%0a" +
          "Referrer's email address: " +
          sessionStorage.getItem("a") +
          "%0d%0a" +
          "Referrer's contact number: " +
          sessionStorage.getItem("b") +
          "%0d%0a" +
          "Referrer's mobile number: " +
          sessionStorage.getItem("c") +
          "%0d%0a" +
          "========================================" +
          "%0d%0a" +
          "Property Address : " +
          val.address +
          " " +
          val.suburb +
          " " +
          val.state +
          " " +
          val.postcode +
          "%0d%0a" +
          "Property Type : " +
          "Houses" +
          "%0d%0a" +
          "Price : " +
          "$" +
          val.price +
          maxPrice +
          "%0d%0a" +
          "Estimated rent per week : " +
          "$" +
          val.rental +
          maxRental +
          "%0d%0a" +
          "Rental yield : " +
          val.rentalYield +
          "%" +
          "%0d%0a" +
          "Vacancy rate : " +
          val.vacancyRate +
          "%" +
          "%0d%0a" +
          "Build Size : " +
          val.buildSize +
          "m2" +
          "%0d%0a" +
          "Beds : " +
          val.bedsNumber +
          "%0d%0a" +
          "Bathrooms : " +
          val.bathroomsNumber +
          "%0d%0a" +
          "Car Spaces : " +
          val.carSpacesNumber +
          "%0d%0a" +
          "Additional Comments : " +
          "%0d%0a" +
          "A Unifi representative will be in touch within the next 24-48 Hours." +
          "%0d%0a";
      } else if (val.proertyType == "House & Land") {
        that.link =
          "mailto:" +
          this.contactEmail +
          "?subject=<Submit Request Form>&body=" +
          "Referrer's name: " +
          sessionStorage.getItem("d") +
          "%0d%0a" +
          "Referrer's email address: " +
          sessionStorage.getItem("a") +
          "%0d%0a" +
          "Referrer's contact number: " +
          sessionStorage.getItem("b") +
          "%0d%0a" +
          "Referrer's mobile number: " +
          sessionStorage.getItem("c") +
          "%0d%0a" +
          "========================================" +
          "%0d%0a" +
          "Property Address : " +
          val.address +
          " " +
          val.suburb +
          " " +
          val.state +
          " " +
          val.postcode +
          "%0d%0a" +
          "Property Type : " +
          "House and Land" +
          "%0d%0a" +
          "Price : " +
          "$" +
          val.price +
          maxPrice +
          "%0d%0a" +
          "Estimated rent per week : " +
          "$" +
          val.rental +
          maxRental +
          "%0d%0a" +
          "Rental yield : " +
          val.rentalYield +
          "%" +
          "%0d%0a" +
          "Vacancy rate : " +
          val.vacancyRate +
          "%" +
          "%0d%0a" +
          "Land Size : " +
          val.labdSize +
          "m2" +
          "%0d%0a" +
          "Land Price : " +
          "$" +
          val.landPrice +
          "%0d%0a" +
          "Build Size : " +
          val.buildSize +
          "m2" +
          "%0d%0a" +
          "Build Price : " +
          "$" +
          val.buildPrice +
          "%0d%0a" +
          "Beds : " +
          val.bedsNumber +
          "%0d%0a" +
          "Bathrooms : " +
          val.bathroomsNumber +
          "%0d%0a" +
          "Car Spaces : " +
          val.carSpacesNumber +
          "%0d%0a" +
          "Additional Comments : " +
          "%0d%0a" +
          "A UNIFI representative will be in touch within the next 24-48 Hours." +
          "%0d%0a";
      } else {
        that.link =
          "mailto:team@unifiproperty.com?subject=<Submit Request Form>&body=" +
          "Referrer's name: " +
          sessionStorage.getItem("d") +
          "%0d%0a" +
          "Referrer's email address: " +
          sessionStorage.getItem("a") +
          "%0d%0a" +
          "Referrer's contact number: " +
          sessionStorage.getItem("b") +
          "%0d%0a" +
          "Referrer's mobile number: " +
          sessionStorage.getItem("c") +
          "%0d%0a" +
          "========================================" +
          "%0d%0a" +
          "Property Address : " +
          val.address +
          " " +
          val.suburb +
          " " +
          val.state +
          " " +
          val.postcode +
          "%0d%0a" +
          "Property Type : " +
          val.proertyType +
          "%0d%0a" +
          "Price : " +
          "$" +
          val.price +
          maxPrice +
          "%0d%0a" +
          "Estimated rent per week : " +
          "$" +
          val.rental +
          maxRental +
          "%0d%0a" +
          "Rental yield : " +
          val.rentalYield +
          "%" +
          "%0d%0a" +
          "Vacancy rate : " +
          val.vacancyRate +
          "%" +
          "%0d%0a" +
          "Land Size : " +
          val.labdSize +
          "m2" +
          "%0d%0a" +
          "Build Size : " +
          val.buildSize +
          "m2" +
          "%0d%0a" +
          "Beds : " +
          val.bedsNumber +
          "%0d%0a" +
          "Bathrooms : " +
          val.bathroomsNumber +
          "%0d%0a" +
          "Car Spaces : " +
          val.carSpacesNumber +
          "%0d%0a" +
          "Additional Comments : " +
          "%0d%0a" +
          "A UNIFI representative will be in touch within the next 24-48 Hours." +
          "%0d%0a";
      }
      that.link = that.link.replace(
        " UNIFI ",
        " " + that.tenant.toUpperCase() + " "
      );
    },
    contactCallback(res) {
      var that = this;
      if (res.data.code == 0) {
        this.contactEmail = res.data.data.contactEmail;
        this.contactNumber = res.data.data.contactPhone;
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 90001
      ) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
      if (that.datum !== null) {
        that.setLink(that.datum);
      }
    }
  },
  computed: {
    ...mapState({
      datum: state => state.property.propertyDtl
    })
  },
  watch: {
    datum(newVal) {
      var that = this;
      that.setLink(newVal);
    }
  }
};
</script>

<style lang="scss" scoped>
.reserveWrapper {
  width: 100%;
  padding-bottom: 0.3rem;
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  background-image: url("https://s3.ap-southeast-2.amazonaws.com/com.unifiproperty/files/images/202007tswZY21nGL");
  color: #fff;

  h1 {
    font-size: 0.52rem;
    padding-top: 0.64rem;
    line-height: 0.78rem;
    margin-bottom: 0.2rem;
    text-align: center;
  }

  h2 {
    font-size: 0.28rem;
    line-height: 0.48rem;
    margin-bottom: 0.5rem;
    text-align: center;
    box-sizing: border-box;
    padding: 0 0.3rem;
  }

  .btn {
    width: 5.18rem;
    height: 0.92rem;
    margin: 0 auto 0.46rem auto;
    display: block;
    border: none;
    cursor: pointer;
    background: rgba(44, 202, 115, 1);
    border-radius: 0.12rem;
    text-align: center;
    line-height: 0.92rem;
    font-size: 0.28rem;
    color: #fff;
    font-family: ProximaNova-Semibold;
  }
}

.link {
  display: inline-block;
  cursor: pointer;
  width: 210px;
  height: 52px;
  background: rgba(44, 202, 115, 1);
  border-radius: 6px;
  text-align: center;
  line-height: 52px;
  font-size: 15px;
  color: #fff;
  text-decoration: none;
}

.line {
  width: 100%;
  height: 4px;
  background: #fff;
}

.popWrp {
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 16;

  .out {
    width: 100%;
    box-sizing: border-box;
    padding: 0 0.24rem;
    height: 7.68rem;
    position: absolute;
    left: 50%;
    top: 50%;
    margin: -3.84rem 0 0 -50%;
  }

  .short {
    height: 6.28rem;
    margin-top: -3.13rem;
  }

  .inn {
    width: 100%;
    height: 7.68rem;
    background: #fff;
    border-radius: 3px;
    overflow: hidden;
    box-sizing: border-box;
    padding-top: 1.6rem;
    position: relative;

    h1 {
      font-size: 0.48rem;
      line-height: 0.58rem;
      font-family: ProximaNova-Semibold;
      color: #3f3f46;
      margin-bottom: 0.6rem;
      position: relative;
      text-align: center;
    }

    h1:after {
      content: "";
      display: block;
      position: absolute;
      left: 0.6rem;
      bottom: -0.2rem;
      width: 1.16rem;
      height: 0.06rem;
      //background: #FFEF00;
    }

    h2 {
      font-size: 0.3rem;
      line-height: 0.6rem;
      text-align: center;
      color: #2a2929;
      margin-bottom: 0.5rem;
      box-sizing: border-box;
      padding: 0 0.46rem;
      text-align: center;
    }

    .btns {
      width: 100%;
      margin: 0 auto;
      box-sizing: border-box;

      button,
      .link {
        display: block;
        width: 3.6rem;
        height: 0.92rem;
        border-radius: 0.12rem;
        line-height: 0.92rem;
        text-align: center;
        font-size: 0.3rem;
        box-sizing: border-box;
        cursor: pointer;
        margin: 0 auto 0.5rem auto;
      }

      button {
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(44, 202, 115, 1);
        color: #2a2929;
        font-family: ProximaNova-Semibold;
      }

      .link {
        background: rgba(44, 202, 115, 1);
        border: 1px solid rgba(44, 202, 115, 1);
        color: #fff;
        font-family: ProximaNova-Semibold;
      }
    }

    .close {
      display: block;
      margin: 0 auto;
      width: 254px;
      height: 52px;
      border-radius: 6px;
      line-height: 52px;
      text-align: center;
      font-size: 15px;
      box-sizing: border-box;
      cursor: pointer;
      background: rgba(44, 202, 115, 1);
      border: 1px solid rgba(44, 202, 115, 1);
      color: #fff;
      font-family: ProximaNova-Semibold;
    }
  }

  .short {
    .inn {
      height: 6.28rem;
    }
  }

  .inn:after {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 10px;
    //background: #FFEF00;
  }

  .shot {
    height: 6.28rem;
    margin-top: -3.14rem;

    .inn {
      height: 6.28rem;
    }
  }
}

.swiper-button-prev {
  background-image: url("../../assets/p.png");
  background-size: 40px 40px;
  width: 40px;
  height: 40px;
  left: 15px;
}

.swiper-button-next {
  background-image: url("../../assets/n.png");
  background-size: 40px 40px;
  width: 40px;
  height: 40px;
  right: 15px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/package/reserve.vue